// ─── Venue: Card Refined ──────────────────────────────────────
// Split card with image on left, details on right.
// Rounded corners, soft shadow, refined editorial feel.

import React from 'react';
import { MapPin, ArrowRight } from 'lucide-react';
import { AnimatedSection } from '../../../lib/animations/AnimatedSection';

export default function VenueCardRefined({ section, data, theme }) {
  const anim = section.animation || {};
  const { venueName, address, mapLink, note, image } = data;

  return (
    <section className="px-6 py-20 sm:py-24" data-testid="venue-section">
      <div className="mx-auto max-w-6xl">
        <AnimatedSection preset={anim.section || 'fade-up'}>
          <div
            className="overflow-hidden rounded-[2rem] border shadow-[0_16px_50px_rgba(0,0,0,0.06)] md:grid md:grid-cols-[1fr_0.95fr]"
            style={{ backgroundColor: theme.surface, borderColor: theme.border }}
          >
            {image && (
              <img
                src={image}
                alt={venueName || 'Venue'}
                className="h-[320px] w-full object-cover md:h-full"
                loading="lazy"
              />
            )}
            <div className="p-8 sm:p-10 md:p-12">
              <p
                className="text-[11px] uppercase tracking-[0.18em] mb-2"
                style={{ color: theme.textSecondary, fontFamily: theme.eyebrowFont }}
              >
                Venue
              </p>
              <h3
                className="text-3xl sm:text-4xl"
                style={{ fontFamily: theme.headingFont, color: theme.textPrimary }}
              >
                {venueName}
              </h3>
              {address && (
                <div className="mt-4 flex items-start gap-3">
                  <MapPin className="mt-1 h-5 w-5 flex-shrink-0" style={{ color: theme.accent }} />
                  <p style={{ color: theme.textSecondary }}>{address}</p>
                </div>
              )}
              {note && (
                <p className="mt-5 leading-7" style={{ color: theme.textSecondary }}>
                  {note}
                </p>
              )}
              {mapLink && (
                <a
                  href={mapLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-8 inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-medium transition hover:opacity-90"
                  style={{ backgroundColor: theme.buttonBg, color: theme.buttonText }}
                >
                  Open map
                  <ArrowRight className="h-4 w-4" />
                </a>
              )}
            </div>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}
